import React, { useState } from 'react';
import SelectUi from '../../ui/select.ui';
import { UserRole } from '../../user/user.type';
import logo from '../../media/logo.png';

import styles from './role-selection.module.css';

const roleOptions = [
  { value: UserRole.Founder, title: 'Founder / Entrepreneur' },
  { value: UserRole.SoftwareEngineer, title: 'Software Engineer' },
];

type RoleSelectionUiProps = {
  onUpdateRole: (role: string) => void;
};

const RoleSelectionUi = (props: RoleSelectionUiProps) => {
  const { onUpdateRole } = props;
  const [selectedRole, setSelectedRole] = useState('');

  const handleRoleChange = (role: string) => {
    setSelectedRole(role);
  };

  const handleContinue = () => {
    if (selectedRole) {
      onUpdateRole(selectedRole);
    }
  };

  return (
    <div className={styles.container}>
      <img
        src={logo}
        alt="Foundermatcha Logo"
        className={styles.logo}
      />
      <div className={styles.subtitle}>
        To personalize your experience, please select your role:
      </div>

      <SelectUi
        key="role-select"
        id="role"
        options={roleOptions}
        value={selectedRole}
        placeholder={'I am a...'}
        onChange={handleRoleChange}
      />

      <div className={styles.description}>
        This helps us match you with the right people.
      </div>

      <button
        onClick={handleContinue}
        disabled={!selectedRole}
        className={styles.button}
      >
        Continue
      </button>
    </div>
  );
};

export default RoleSelectionUi;
